import { ApiService } from "./ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export interface SubCategory {
  subClassId: string;
  subClassName: string;
  categoryId: string | null;
}

export interface BookCategory {
  categoryId: string;
  categoryName: string;
  subClasses: SubCategory[];
}

export const CategoryApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getListOfCategories: builder.query<any[], void>({
      query: () => ({
        url: `/categories`,
        method: "GET",
      }),
      transformResponse: (res: ResultsDTO<any[]>) => res.results ?? [],
    }),

    getCategoriesByProductType: builder.query<BookCategory[], string | void>({
      query: (productType) => ({
        url: `/categories/by-product-type`,
        method: "GET",
        headers: {
          origin: "AlphabitEcommerce.0.1",
        },
        params: productType ? { productType } : {},
      }),
      transformResponse: (response: ResultsDTO<BookCategory[]>) =>
        response.results ?? [],
    }),
  }),
});

export const {
  useGetListOfCategoriesQuery,
  useGetCategoriesByProductTypeQuery,
} = CategoryApiSlice;
